<template>
    <v-layout row wrap mt-3>
        <v-flex
            xs12
            class="comments-card mb-3"
            v-for="(waiverComment,key) in waiverCommentList"
            :key="key">
            <v-card class="comments-card__panelBlock pa-3">
                <v-layout row wrap>
                    <v-flex xs8>
                        <v-list two-line>
                            <v-list-tile>
                                <v-list-tile-avatar>
                                    <img :onerror="imageErrorFallback(waiverComment.commentedUserFallbackProfileImageUrl)" :src="waiverComment.commentedUserProfileImageUrl" :data-qe-id="`lead_profile_image_${key}`">
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title :data-qe-id="`lead_name_${key}`">{{waiverComment.commentedUserFirstName}} {{waiverComment.commentedUserLastName}}</v-list-tile-title>
                                    <v-list-tile-sub-title :data-qe-id="`lead_chaptername_${key}`">{{positionTitle(waiverComment)}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                    </v-flex>
                    <v-flex xs4 text-xs-right class="comments-card__panelBlock__info">
                        <small :data-qe-id="`comment_date_time_${key}`">{{getTimeOfPost(waiverComment.commentDateTime)}}</small>
                        <i class="far fa-clock clock"></i>
                    </v-flex>
                    <v-flex :data-qe-id="`comment_text_${key}`" tag="p" xs12>{{waiverComment.commentText}}</v-flex>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import { getTimeOfPost } from "../../common/utils/dateTime";
    import { imageErrorFallback } from "../../common/utils/utils";
    import { chapterWaiverConstants } from "./ChapterWaiver.constants";

    export default {
        name: "WaiverComments",
        data: () => {
            return {
                chapterWaiverConstants,
            };
        },
        computed: {},
        methods: {
            getTimeOfPost,
            imageErrorFallback,

            positionTitle(waiverComment) {
                let position = '';
                if (waiverComment.commentType && waiverComment.commentType.toLowerCase() === this.chapterWaiverConstants.PRPADMIN.toLowerCase()) {
                    position = this.chapterWaiverConstants.PRP_ADMIN;
                } else if (waiverComment.commentType && waiverComment.commentType.toLowerCase().includes(this.chapterWaiverConstants.REGION.toLowerCase())) {
                    position = `${waiverComment.regionName ? waiverComment.regionName : ''} ${waiverComment.commentedUserTitle ? waiverComment.commentedUserTitle : ''}`;
                }
                return position;
            },
        },
        props: {
            waiverCommentList: {
                type: Array,
                required: true,
            },
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/responsive.scss";

    .comments-card {
        &__panelBlock {
            border-radius: 5px;
            border: 1px rgba($ypo-cta, 0.6) solid !important;
            box-shadow: none;

            .v-list {
                padding-top: 0;

                .v-list__tile {
                    height: auto;
                    padding: 0;

                    .v-list__tile__title {
                        color: $black;
                        font-weight: 600;
                        font-size: 16px;
                    }

                    .v-list__tile__sub-title {
                        font-size: 12px;
                        color: $ypo-gray;
                        font-weight: 500;
                    }
                }
            }

            &__info {
                .clock {
                    font-size: 22px;
                    color: rgba($ypo-cta, 0.4);
                    padding: 0 15px;
                }

                small {
                    font-size: 14px;
                    font-weight: 500;
                    vertical-align: top;
                }
            }

            p {
                font-size: 14px;
                font-weight: 500;
            }
        }

    }
</style>
